import { Link } from 'react-router-dom';
import { HIGHWAYS_BASE_PATH } from '../routes/Routes';

const highwaysList = ['Road', 'Pavement'];

export const TestLandingPage = () => {
  return (
    <main>
      <div className="flex flex-col gap-x-2">
        <h1 className="my-6 text-2xl font-semibold">Most reported</h1>
        <section>
          <ul className="text-brand-primary flex flex-col gap-4 underline">
            {highwaysList.map((item: string) => (
              <li key={item} className="text-bodyLg">
                <Link to={`${HIGHWAYS_BASE_PATH}?type=${item.toLowerCase()}`}>
                  {item}
                </Link>
                <hr className="border-brand-primary border-1 my-3 border-opacity-25" />
              </li>
            ))}
          </ul>
        </section>
      </div>
    </main>
  );
};
